import { render } from "./damavi.vue?vue&type=template&id=83b0c35e"
import script from "./damavi.vue?vue&type=script&lang=js"
export * from "./damavi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/tabibekhanevade-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__